import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ContentCardStyles } from '@stories/Components/Cards/ContentCard/ContentCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    display: flex;
    flex-direction: column;
  }
`;
const TopSection = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;
const Title = styled.h2 `
  color: var(--sectionForegroundColor);
  ${fonts.ubuntu.bold};
  font-size: ${fluid(40, 48)};
  line-height: ${fluid(45, 55)};
  letter-spacing: -1px;

  margin-bottom: 12px;

  &[data-show-underline='true'] {
    border-bottom: ${fluid(1, 2)} solid var(--sectionForegroundColor);
    padding-bottom: ${fluid(20, 26)};
    margin-bottom: ${fluid(20, 26)};
  }
`;
const Intro = styled.p `
  color: var(--sectionForegroundColor);
  ${fonts.ubuntu.regular};
  font-size: ${fluid(18, 24)};
  line-height: ${fluid(24, 28)};
`;
const CardsGrid = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  row-gap: 30px;

  ${ContentCardStyles.Container} {
    flex-grow: 1;
    flex-shrink: 1;

    flex-basis: calc(100%);

    @media ${from(Device.Tablet)} {
      flex-basis: calc((100% / 2) - 16px);
    }

    @media ${from(Device.TabletLarge)} {
      flex-basis: calc(100% / ${(props) => props['data-cards-per-row']} - 16px);
    }
  }
`;
export const ContentCardsStyles = {
    Container,
    TopSection,
    Title,
    Intro,
    CardsGrid,
};
